export default __webpack_public_path__ + "static/Long-7dd6fe4c97447acae514f13245f3e3a5.png";